import { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Form } from 'react-bootstrap';
import { filterEmptyFields } from '../../utils/formUtils';
import {
  Button,
  Dialog,
  Backdrop,
  TextField,
  IconButton,
  Typography,
  InputLabel,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Select from 'react-select';
import Modal from '../../components/common/Modal';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { v4 as uuidv4 } from 'uuid';
import * as gen from '../../graphql-generated';
import awsExports from '../../aws-exports';
import { AsyncSelectField } from 'components/Fields';
import { useNotification } from 'hooks/useNotification';
import { unitAPI, federatedUnitAPI } from 'services/admin';

function ModalUnits(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [selectErrorRequired, setSelectErrorRequired] = useState('');
  const [isStateLoading, setIsStateLoading] = useState(false);
  const [isCityLoading, setIsCityLoading] = useState(false);
  const [stateOptions, setStateOptions] = useState([]);
  const [stateOptionsDefined, setStateOptionsDefined] = useState([]);
  const [cityDefined, setCityDefined] = useState([]);
  const [cityOptionsDefined, setCityOptionsDefined] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [ufs, setUfs] = useState({});
  const [confirmDialogAction, setConfirmDialogAction] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
  });
  const { setNotify } = useNotification();
  const [isLoadingModalConfirmation, setIsLoadingModalConfirmation] =
    useState(false);
  const { showConfirmationButton } = useState(true);
  const {
    formState: { isDirty, isValid },
    handleSubmit,
    reset,
    setValue,
    getValues,
    watch,
    control,
  } = useForm({
    mode: 'onBlur',
  });
  const [waitTrackCorrelationId, setWaitTrackCorrelationId] = useState(null);
  const [waitAction, setWaitAction] = useState(null);

  async function postData(bodyData) {
    setIsLoading(true);
    const trackCorrelationId = uuidv4();
    setWaitTrackCorrelationId(trackCorrelationId);
    setWaitAction('postData');
    // bodyData.createdBy = { unitId: session.getIdToken().payload.sub, name: session.getIdToken().payload.username }; //TODO: verificar se manda o name do cognito
    // bodyData.updatedBy = {"unitId": session.getIdToken().payload.sub, "name": session.getIdToken().payload.name} //TODO: verificar se manda o name do cognito
    const data = {
      body: bodyData,
      headers: {
        'Content-Type': 'application/json',
        'track-correlation-id': trackCorrelationId,
      },
    };

    return unitAPI
      .post(data)
      .then(() => {
        if (
          awsExports.ENVIRONMENT_NAME !== 'dev' &&
          awsExports.ENVIRONMENT_NAME !== 'hml'
        ) {
          setNotify({
            isOpen: true,
            message: `Unidade criada com sucesso!`,
            type: 'success',
            title: 'Sucesso!',
          });
          setIsLoading(false);
          closeModal();
          props.getUnits();
        }
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
        const errorJson = error.request.response;
        const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: parseJson.message,
          type: 'error',
          title: 'Ops! Algo deu errado...',
        });
      });
  }

  async function putData(bodyData) {
    setIsLoading(true);
    const trackCorrelationId = uuidv4();
    setWaitTrackCorrelationId(trackCorrelationId);
    setWaitAction('putData');
    // bodyData.createdBy = { unitId: session.getIdToken().payload.sub, name: session.getIdToken().payload.username }; //TODO: verificar se manda o name do cognito

    const data = {
      body: bodyData,
      headers: {
        'Content-Type': 'application/json',
        'track-correlation-id': trackCorrelationId,
      },
    };

    return unitAPI
      .put(`/${props.unit.id}`, data)
      .then(() => {
        if (
          awsExports.ENVIRONMENT_NAME !== 'dev' &&
          awsExports.ENVIRONMENT_NAME !== 'hml'
        ) {
          setNotify({
            isOpen: true,
            message: `Unidade atualizada com sucesso!`,
            type: 'success',
            title: 'Sucesso!',
          });
          setIsLoading(false);
          closeModal();
          props.getUnits();
        }
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
        const errorJson = error.request.response;
        const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: parseJson.message,
          type: 'error',
          title: 'Ops! Algo deu errado...',
        });
      });
  }

  async function deleteData() {
    setIsLoadingModalConfirmation(true);
    const trackCorrelationId = uuidv4();
    setWaitTrackCorrelationId(trackCorrelationId);
    setWaitAction('deleteData');
    const data = {
      headers: {
        'Content-Type': 'application/json',
        'track-correlation-id': trackCorrelationId,
      },
    };

    unitAPI
      .del(`/${props.unit.id}`, data)
      .then(() => {
        if (
          awsExports.ENVIRONMENT_NAME !== 'dev' &&
          awsExports.ENVIRONMENT_NAME !== 'hml'
        ) {
          setNotify({
            isOpen: true,
            message: `Unidade "${props.unit.name}" removida!`,
            type: 'success',
            title: 'Sucesso!',
          });
          setIsLoading(false);
          setConfirmDialogAction({ isOpen: false });
          closeModal();
          setIsLoadingModalConfirmation(false);
          props.getUnits();
        }
      })
      .catch(error => {
        console.log(error);
        setConfirmDialogAction({ isOpen: false });
        setIsLoadingModalConfirmation(false);
        const errorJson = error.request.response;
        const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: `${parseJson.message}: A unidade "${props.unit.name}" tem ${props.unit.linkedVideosCount} video(s), ${props.unit.linkedCollectionsCount} coleção(ões) e ${props.unit.linkedUsersCount} usuário(s) associados, remova os vinculos para prosseguir com a remoção da unidade.`,
          type: 'error',
          title: 'Ops! Algo deu errado...',
        });
      });
  }

  //Define the channel name here
  let channel = 'admin-events';
  // let waitingTrackCorrelationId = null;

  async function handleReceived(
    data,
    waitTrackCorrelationId,
    waitAction,
    props
  ) {
    let dataAsJson = JSON.parse(data);
    if (dataAsJson.trackCorrelationId !== waitTrackCorrelationId) {
      return;
    }
    if ('postData' === waitAction) {
      setNotify({
        isOpen: true,
        message: `Unidade criada com sucesso!`,
        type: 'success',
        title: 'Sucesso!',
      });
      setIsLoading(false);
      closeModal();
      props.getUnits();
    } else if ('putData' === waitAction) {
      setNotify({
        isOpen: true,
        message: `Unidade atualizada com sucesso!`,
        type: 'success',
        title: 'Sucesso!',
      });
      setIsLoading(false);
      closeModal();
      props.getUnits();
    } else if ('deleteData' === waitAction) {
      setNotify({
        isOpen: true,
        message: `Unidade "${props.unit.name}" removida!`,
        type: 'success',
        title: 'Sucesso!',
      });
      setIsLoading(false);
      setConfirmDialogAction({ isOpen: false });
      closeModal();
      setIsLoadingModalConfirmation(false);
      props.getUnits();
    }
  }

  useEffect(() => {
    if (
      awsExports.ENVIRONMENT_NAME === 'dev' ||
      awsExports.ENVIRONMENT_NAME === 'hml'
    ) {
      //Subscribe via WebSockets
      const subscription = gen.subscribe(channel, ({ data }) =>
        handleReceived(data, waitTrackCorrelationId, waitAction, props)
      );
      return () => subscription.unsubscribe();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channel, waitTrackCorrelationId, waitAction, props]);

  async function getUfs() {
    return new Promise((resolve, reject) => {
      setIsStateLoading(true);

      federatedUnitAPI
        .get()
        .then(resp => {
          setUfs(resp);
          resolve(resp);
          setIsStateLoading(false);
        })
        .catch(error => {
          console.log(error);
          setIsStateLoading(false);
        });
    });
  }

  useEffect(() => {
    //On Modal Open
    if (props.open === true) {
      // Set initial values
      setValue('name', props.unit.name ? props.unit.name : '');
      setValue('address', props.unit.address ? props.unit.address : '');
      setValue('stateId', props.unit.state ? props.unit.state : '');
      setValue('cityId', props.unit.city ? props.unit.city : '');
      setValue('latitude', props.unit.latitude ? props.unit.latitude : '');
      setValue('longitude', props.unit.longitude ? props.unit.longitude : '');
      setValue(
        'users',
        props.unit.linkedUsers
          ? props.unit.linkedUsers.map(user => ({
              value: user.userId,
              label: user.name,
            }))
          : []
      );

      // setValue("users", props.unit.linkedUsers ? props.unit.linkedUsers.map((user) => ({ userId: user.id })) : []);

      // setIsLoading(true)
      Promise.all([getUfs()]).then(promises => {
        if (props.action === 'create') {
          setStateOptions(
            promises[0]['ufList'].map(uf => {
              return {
                value: uf.id,
                label: uf.name,
              };
            })
          );
          setStateOptionsDefined(
            promises[0]['ufList'].map(uf => {
              return {
                value: uf.id,
                label: uf.name,
              };
            })
          );
          setIsStateLoading(false);
        } else if (props.action === 'edit') {
          setStateOptions(
            promises[0]['ufList'].map(uf => {
              return {
                value: uf.id,
                label: uf.name,
              };
            })
          );
          setCityOptions(
            promises[0]['ufList']
              .find(uf => uf.id === props.unit.state.stateId)
              .cities.map(city => ({
                label: city.name,
                value: city.cityId,
              }))
          );
          setCityOptionsDefined(
            promises[0]['ufList']
              .find(uf => uf.id === props.unit.state.stateId)
              .cities.map(city => ({
                label: city.name,
                value: city.cityId,
              }))
          );
          setStateOptionsDefined(
            promises[0]['ufList'].map(uf => {
              return {
                value: uf.id,
                label: uf.name,
              };
            })
          );
          setIsStateLoading(false);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open, props.authenticatedUnits]);

  useEffect(() => {
    if (stateOptionsDefined.length >= 1) {
      let selectedOption = stateOptionsDefined.find(
        element => element.label === 'São Paulo'
      );
      handleStateChange(selectedOption);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateOptionsDefined]);

  useEffect(() => {
    if (cityOptionsDefined.length >= 1) {
      let selectedOption = cityOptionsDefined.find(
        element => element.value === props.unit.city.cityId
      );
      setCityDefined(selectedOption);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cityOptionsDefined]);

  const handleStateChange = selectedOption => {
    setValue('cityId', '');
    setIsCityLoading(true);
    setCityOptions(
      ufs.ufList
        .find(uf => uf.id === selectedOption.value)
        .cities.map(city => ({
          label: city.name,
          value: city.cityId,
        }))
    );
    setIsCityLoading(false);
  };

  const onSubmit = data => {
    const formValues = getValues();
    //Prepare phoneNumber
    // Remove fields with empty values
    let filteredFormValues = filterEmptyFields(formValues);
    // If channels exist, format it
    if (filteredFormValues.users)
      filteredFormValues.users = filteredFormValues.users.map(user => ({
        userId: user.value,
      })); //TODO o user e o channel estao como o nome, mas o back espera o id deles

    //Definindo o valor do Estado para SP, quando a opcao de escolher outros estados existir, devemos alterar.
    filteredFormValues['stateId'] = stateOptionsDefined[0].value;

    if (props.action === 'edit') {
      filteredFormValues['cityId'] = cityDefined.value;
      putData(filteredFormValues).then(() => {
        if (
          awsExports.ENVIRONMENT_NAME !== 'dev' &&
          awsExports.ENVIRONMENT_NAME !== 'hml'
        ) {
          closeModal();
        }
      });
    } else if (props.action === 'create') {
      postData(filteredFormValues)
        .then(() => {
          if (
            awsExports.ENVIRONMENT_NAME !== 'dev' &&
            awsExports.ENVIRONMENT_NAME !== 'hml'
          ) {
            // Reset all fields after post
            closeModal();
            props.getUnits();
            // setActive(undefined)
          }
        })
        .catch(error => {
          console.log(error);
          //TODO: o que acontece se der erro na inserção?
        });
    }
  };

  function closeModal() {
    setSelectErrorRequired('');
    reset();
    props.onClose();
  }

  return (
    <>
      <Dialog open={props.open} onClose={closeModal}>
        <Backdrop open={isLoading} style={{ zIndex: 9999 }}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Form onSubmit={handleSubmit(onSubmit)} style={{ width: 480 }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingTop: 12,
            }}>
            <DialogTitle
              style={{ lineHeight: 0, color: 'rgba(16, 24, 40, 1)' }}>
              {props.action === 'edit' ? 'Editar unidade' : 'Criar unidade'}
            </DialogTitle>
          </div>
          <IconButton
            aria-label="close"
            onClick={closeModal}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme => theme.palette.grey[500],
            }}>
            <CloseIcon />
          </IconButton>

          <Typography
            style={{ paddingRight: 24, paddingTop: 4, paddingLeft: 24 }}>
            Preencha as informações de uma nova unidade.
          </Typography>
          <DialogContent>
            <Form.Group className="mb-3" controlId="formName">
              <div className="label-content">
                <label className="max-char-name">40 caracteres</label>
                <InputLabel className="form-label" htmlFor="name">
                  Nome
                </InputLabel>
              </div>

              <Controller
                name={'name'}
                control={control}
                rules={{
                  required: 'O nome é obrigatório.',
                  minLength: { value: 3, message: 'Mínimo de 3 caracteres' },
                  maxLength: { value: 40, message: 'Máximo de 40 caracteres' },
                }}
                render={({
                  field: { onChange, value, onBlur },
                  fieldState: { error },
                }) => (
                  <TextField
                    helperText={
                      error ? (
                        <span style={{ fontSize: '16px' }}>
                          {' '}
                          {error.message}{' '}
                        </span>
                      ) : null
                    }
                    error={!!error}
                    onChange={e => {
                      onChange(e);
                      // setSelectedName(e.target.value)
                    }}
                    value={value}
                    fullWidth
                    placeholder="Digite o nome"
                    variant="standard"
                    onBlur={onBlur}
                    disabled={
                      props.unit.deleted === true
                        ? true
                        : props.unit.deleted === 'true'
                          ? true
                          : false
                    }
                    id="unit_name"
                  />
                )}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formAddress">
              <InputLabel className="form-label" htmlFor="address">
                Endereço
              </InputLabel>
              <Controller
                name={'address'}
                control={control}
                rules={{
                  required: 'O endereço é obrigatório.',
                }}
                render={({
                  field: { onChange, value, onBlur },
                  fieldState: { error, invalid, isTouched, isDirty },
                  formState,
                }) => (
                  <TextField
                    helperText={
                      error ? (
                        <span style={{ fontSize: '16px' }}>
                          {' '}
                          {error.message}{' '}
                        </span>
                      ) : null
                    }
                    error={!!error}
                    onChange={e => {
                      onChange(e);
                      // setSelectedName(e.target.value)
                    }}
                    value={value}
                    fullWidth
                    placeholder="Digite o endereço"
                    variant="standard"
                    onBlur={onBlur}
                    disabled={
                      props.unit.deleted === true
                        ? true
                        : props.unit.deleted === 'true'
                          ? true
                          : false
                    }
                    id="unit_address"
                  />
                )}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formState">
              <InputLabel
                className="form-label"
                id="select-standard-label"
                htmlFor="stateId">
                Estado
              </InputLabel>
              <Controller
                name={'stateId'}
                control={control}
                // rules={{
                //   required: "O estado é obrigatório.",
                // }}
                render={({
                  field: { onChange, value, onBlur },
                  fieldState: { error, invalid, isTouched, isDirty },
                  formState,
                }) => (
                  <Select
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        '&:hover': {
                          borderColor: '#464646',
                        },
                        borderRadius: '5px',
                        width: 'auto',
                        padding: 0,
                        margin: 0,
                      }),
                      singleValue: base => ({
                        ...base,
                        // padding: 5,
                        borderRadius: 6,
                        color: '#878787',
                        //color: props.action === "create" ? "#B7B5BE" : props.unit.deleted === true ? "#B7B5BE" : props.unit.deleted === "true" ? "#B7B5BE" : "#343b45",
                        cursor: 'not-allowed',
                        fontSize: '15px',
                        display: 'flex',
                      }),
                      menuList: base => ({
                        ...base,
                        maxHeight: '150px',
                      }),
                    }}
                    theme={theme => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        primary25: '#e9e9ea',
                        primary: '#0A6CCF',
                        width: 'auto',
                      },
                    })}
                    className="basic-single"
                    classNamePrefix="select"
                    isDisabled={true} //desabilitado pois teremos apenas São Paulo a principio
                    openMenuOnClick={
                      props.unit.deleted === true
                        ? false
                        : props.unit.deleted === 'true'
                          ? false
                          : true
                    }
                    isSearchable={
                      props.unit.deleted === true
                        ? false
                        : props.unit.deleted === 'true'
                          ? false
                          : true
                    }
                    placeholder="Selecione"
                    menuPosition="fixed"
                    onBlur={() => setSelectErrorRequired('stateId')}
                    options={stateOptions}
                    value={
                      ['create', 'edit'].includes(props.action)
                        ? stateOptionsDefined
                        : stateOptions.find(c => c.value === value)
                    }
                    isLoading={isStateLoading}
                    onChange={selectedOption => {
                      onChange(selectedOption.value);
                      handleStateChange(selectedOption);
                      // setSelectedName(e.target.value)
                    }}
                    // components={animatedComponents}
                  />
                )}
              />
              {getValues('stateId') === '' &&
                selectErrorRequired === 'stateId' && (
                  <p className="error" role="alert">
                    O estado é obrigatório.
                  </p>
                )}
            </Form.Group>

            <Form.Group className="mb-3" controlId="formCity">
              <InputLabel
                className="form-label"
                id="select-standard-label"
                htmlFor="cities">
                Município
              </InputLabel>
              <Controller
                name={'cityId'}
                control={control}
                rules={
                  props.action === 'create'
                    ? { required: 'O município é obrigatório.' }
                    : ''
                }
                render={({
                  field: { onChange, value, onBlur },
                  fieldState: { error, invalid, isTouched, isDirty },
                  formState,
                }) => (
                  <Select
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        '&:hover': {
                          borderColor: '#464646',
                        },
                        borderRadius: '5px',
                        width: 'auto',
                        padding: 0,
                        margin: 0,
                      }),
                      singleValue: base => ({
                        ...base,
                        // padding: 5,
                        borderRadius: 6,
                        color:
                          props.unit.deleted === true
                            ? '#B7B5BE'
                            : props.unit.deleted === 'true'
                              ? '#B7B5BE'
                              : '#343b45',
                        fontSize: '15px',
                        display: 'flex',
                      }),
                      menuList: base => ({
                        ...base,
                        maxHeight: '150px',
                      }),
                    }}
                    theme={theme => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        primary25: '#e9e9ea',
                        primary: '#0A6CCF',
                        width: 'auto',
                      },
                    })}
                    noOptionsMessage={() => 'Nada encontrado'}
                    loadingMessage={() => 'Carregando...'}
                    className="basic-single"
                    classNamePrefix="select"
                    isDisabled={
                      props.unit.deleted === true
                        ? true
                        : props.unit.deleted === 'true'
                          ? true
                          : false
                    }
                    openMenuOnClick={
                      props.unit.deleted === true
                        ? false
                        : props.unit.deleted === 'true'
                          ? false
                          : true
                    }
                    isSearchable={
                      props.unit.deleted === true
                        ? false
                        : props.unit.deleted === 'true'
                          ? false
                          : true
                    }
                    // placeholder={props.action === "edit" ? props.unit.city.cityName : "Selecione"}
                    menuPosition="fixed"
                    onBlur={() => setSelectErrorRequired('cityId')}
                    placeholder="Buscar..."
                    options={cityOptions}
                    value={
                      props.action === 'create'
                        ? stateOptions.find(c => c.value === value)
                        : cityDefined
                    } //{props.action === "edit" ? cityDefined : stateOptions.find((c) => c.value === value)}
                    isLoading={isCityLoading}
                    onChange={selectedOption => {
                      onChange(selectedOption.value);
                      setCityDefined(selectedOption);
                    }}
                    // isDisabled={getValues("stateId") === ""}
                    // components={animatedComponents}
                  />
                )}
              />
              {getValues('cityId') === '' &&
                selectErrorRequired === 'cityId' && (
                  <p className="error" role="alert">
                    O município é obrigatório.
                  </p>
                )}
            </Form.Group>

            <Form.Group className="mb-3" controlId="formLatitude">
              <InputLabel className="form-label" htmlFor="latitude">
                Latitude
              </InputLabel>
              <Controller
                name={'latitude'}
                control={control}
                render={({
                  field: { onChange, value, onBlur },
                  fieldState: { error, invalid, isTouched, isDirty },
                  formState,
                }) => (
                  <TextField
                    helperText={
                      error ? (
                        <span style={{ fontSize: '16px' }}>
                          {' '}
                          {error.message}{' '}
                        </span>
                      ) : null
                    }
                    error={!!error}
                    onChange={e => {
                      onChange(e);
                      // setSelectedName(e.target.value)
                    }}
                    value={value}
                    fullWidth
                    type="number"
                    placeholder="Digite a latitude"
                    variant="standard"
                    onBlur={onBlur}
                    disabled={
                      props.unit.deleted === true
                        ? true
                        : props.unit.deleted === 'true'
                          ? true
                          : false
                    }
                    id="unit_latitude"
                  />
                )}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formLongitude">
              <InputLabel className="form-label" htmlFor="longitude">
                Longitude
              </InputLabel>
              <Controller
                name={'longitude'}
                control={control}
                render={({
                  field: { onChange, value, onBlur },
                  fieldState: { error, invalid, isTouched, isDirty },
                  formState,
                }) => (
                  <TextField
                    helperText={
                      error ? (
                        <span style={{ fontSize: '16px' }}>
                          {' '}
                          {error.message}{' '}
                        </span>
                      ) : null
                    }
                    error={!!error}
                    onChange={e => {
                      onChange(e);
                      // setSelectedName(e.target.value)
                    }}
                    value={value}
                    fullWidth
                    type="number"
                    placeholder="Digite a longitude"
                    variant="standard"
                    onBlur={onBlur}
                    disabled={
                      props.unit.deleted === true
                        ? true
                        : props.unit.deleted === 'true'
                          ? true
                          : false
                    }
                    id="unit_longitude"
                  />
                )}
              />
            </Form.Group>
            <Form.Group
              className="mb-3"
              style={{ height: 'auto' }}
              controlId="formUser">
              <InputLabel
                className="form-label"
                id="select-standard-label"
                htmlFor="users">
                Usuários vinculados ({watch('users')?.length || 0})
              </InputLabel>
              <AsyncSelectField
                id="unit_users"
                name="users"
                isMulti
                placeholder="Buscar..."
                isDisabled={
                  props.unit.deleted === true
                    ? true
                    : props.unit.deleted === 'true'
                      ? true
                      : false
                }
                openMenuOnClick={
                  props.unit.deleted === true
                    ? false
                    : props.unit.deleted === 'true'
                      ? false
                      : true
                }
                control={control}
                url="/admin/users?performance=true&limit=10&name=#name&sortBy=name&offset=#offset"
                responseKey="userList"
                isOptionDisabled={option => option.role === 'ADMIN'}
              />
            </Form.Group>
          </DialogContent>
          <DialogActions style={{ padding: '0 24px 24px' }}>
            {props.action === 'edit' && (
              <Button
                id="unit_remove_btn"
                style={{
                  color: 'rgba(52, 64, 84, 1)',
                  borderRadius: 8,
                  background: 'rgba(255, 255, 255, 1)',
                  borderColor: 'rgba(208, 213, 221, 1)',
                  padding: '10px 18px',
                  marginLeft: 12,
                  pointerEvents:
                    props.unit.deleted === true
                      ? 'none'
                      : props.unit.deleted === 'true'
                        ? 'none'
                        : '',
                }}
                onClick={() =>
                  setConfirmDialogAction({
                    isOpen: true,
                    title: `Remover ${props.unit.name}?`,
                    subTitle: `Você está removendo a unidade "${props.unit.name}" permanentemente. Clique remover para confirmar.`,
                    confirmTextButton: 'Remover',
                    color: 'error',
                    children: (
                      <div className="modalRemoveItem">
                        <DeleteOutlineOutlinedIcon
                          color="error"
                          fontSize="8px"
                        />
                      </div>
                    ),
                    onConfirm: () => {
                      deleteData();
                    },
                    showConfirmationButton: { showConfirmationButton },
                    closeTextButton: 'Cancelar',
                  })
                }
                variant="contained"
                className={
                  props.unit.deleted === true
                    ? 'disabled_inactive_button'
                    : props.unit.deleted === 'true'
                      ? 'disabled_inactive_button'
                      : ''
                }>
                Remover
              </Button>
            )}
            <Button
              id="unit_cancel_btn"
              style={{
                marginLeft: 12,
                color: 'rgba(52, 64, 84, 1)',
                borderRadius: 8,
                background: 'rgba(255, 255, 255, 1)',
                borderColor: 'rgba(208, 213, 221, 1)',
                padding: '10px 18px',
              }}
              variant="contained"
              onClick={() => {
                closeModal();
              }}>
              Cancelar
            </Button>
            <Button
              id="unit_save_btn"
              style={{
                color: 'rgba(255, 255, 255, 1)',
                borderRadius: 8,
                marginLeft: 12,
                background: 'rgba(19, 97, 164, 1)',
                borderColor: 'rgba(19, 97, 164, 1)',
                padding: '10px 18px',
              }}
              variant="contained"
              type="submit"
              disabled={!isDirty || !isValid}
              //onClick={() => {}}
              className={
                props.unit.deleted === true
                  ? 'disabled_save_button'
                  : props.unit.deleted === 'true'
                    ? 'disabled_save_button'
                    : ''
              }>
              Salvar
            </Button>
          </DialogActions>
          <Modal
            confirmDialogAction={confirmDialogAction}
            setConfirmDialogAction={setConfirmDialogAction}
            isLoadingModalConfirmation={isLoadingModalConfirmation}
            setIsLoadingModalConfirmation={setIsLoadingModalConfirmation}
            showConfirmationButton={showConfirmationButton}
          />
        </Form>
      </Dialog>
    </>
  );
}

export default ModalUnits;
